module.exports = __webpack_public_path__ + "static/img/registerBg1.40e7627f.png";